import { render, staticRenderFns } from "./VariantSelectButtons.vue?vue&type=template&id=74a8cbae&scoped=true&lang=pug"
import script from "./VariantSelectButtons.vue?vue&type=script&lang=js"
export * from "./VariantSelectButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a8cbae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74a8cbae')) {
      api.createRecord('74a8cbae', component.options)
    } else {
      api.reload('74a8cbae', component.options)
    }
    module.hot.accept("./VariantSelectButtons.vue?vue&type=template&id=74a8cbae&scoped=true&lang=pug", function () {
      api.rerender('74a8cbae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/VariantSelectButtons.vue"
export default component.exports